var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-comitentes m-t"},[_c('h2',{staticClass:"font-16 font-bold text-grey-8 m-b-sm"},[_vm._v("Chat Comitentes")]),_vm._l((_vm.comitentes),function(comitente){return _c('chat-item',{key:comitente.id,attrs:{"comitente":comitente}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }